import React from 'react';
import { useTranslation } from 'react-i18next';
import createAccount1 from '../assets/images/createAccount1.jpg';
import createAccount2 from '../assets/images/createAccount2.jpg';
import sap_ariba_logo from '../assets/images/sap_ariba_logo.jpg.jpeg';
import { ExternalLinkIcon } from 'lucide-react';

const AccountLinks = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mt-10 flex flex-col sm:flex-row justify-center gap-6">
                    <div className="bg-white w-[200px] border shadow-md border-slate-200 rounded-2xl overflow-hidden hover:shadow-md transition-shadow">
                        <div className={`px-4 py-2 ${isAr ? 'text-right' : 'text-left'}`}>
                            <h2 className="text-lg font-extrabold text-slate-900">{t('accountLinks.createAccount')}</h2>
                            <p className="text-sm text-slate-600 mt-2">{t('accountLinks.newSupplier')}</p>
                            <p className="text-sm text-slate-600">{t('accountLinks.ksu')}</p>

                            <a
                                href="https://s1.ksaprv.cloud.ariba.com/Sourcing/Main/ad/selfRegistration?realm=744968928"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`group mt-12 flex items-center text-nowrap w-full justify-center gap-2 rounded-md bg-[#E7E9ED] px-1 py-2.5 text-sm font-bold hover:bg-[#dbdde0] transition-colors`}
                            >
                                <span>{t('accountLinks.createAccountBtn')}</span>
                                <ExternalLinkIcon size={18} className={`transition-transform ${isAr ? 'group-hover:-translate-x-0.5 group-hover:rotate-12' : 'group-hover:translate-x-0.5 group-hover:-rotate-12'}`} />
                            </a>
                        </div>
                    </div>
                    <div className="bg-white border w-[200px] shadow-md border-slate-200 rounded-2xl overflow-hidden hover:shadow-md transition-shadow">
                        <div className='px-4 py-2'>
                            <h2 className="text-lg font-extrabold text-slate-900">{t('accountLinks.haveAccount')}</h2>
                            <p className="text-sm text-slate-600 mt-2">{t('accountLinks.registered')}</p>
                            <p className="text-sm text-slate-600">{t('accountLinks.ksu')}</p>

                            <a
                                href="https://service.ariba.com/Supplier.aw/109542058/aw?awh=r&awssk=zux3Ytwz&dard=1"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`group mt-12 flex text-nowrap items-center w-full justify-center gap-2 rounded-md bg-[#E7E9ED] px-1 py-2.5 text-sm font-bold hover:bg-[#dbdde0] transition-colors`}
                            >
                                <span>{t('accountLinks.loginBtn')}</span>
                                <ExternalLinkIcon size={18} className={`transition-transform ${isAr ? 'group-hover:-translate-x-0.5 group-hover:rotate-12' : 'group-hover:translate-x-0.5 group-hover:-rotate-12'}`} />
                            </a>
                        </div>
                    </div>

                </div>
            </div >
        </section >
    );
};

export default AccountLinks;
